import { Form, Formik } from 'formik';
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaExclamationCircle } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import {
	checkPhoneNumberVerificationToken,
	requestPhoneNumberVerificationToken,
} from '../../../../actions/accountActions';
import { closeAllModals } from '../../../../actions/modalActions';
import { ReactComponent as Close } from '../../../../icons/close-button.svg';
import IAccountReducer from '../../../../interfaces/reducers/accountReducer';
import IUserProfileReducer from '../../../../interfaces/reducers/userProfileReducer';
import { IStore } from '../../../../reducers';
import Button from '../../../base/button/button';
import FormikFieldWrapper from '../../../base/forms/formikFieldWrapper';
import { StyledFormikField } from '../../../base/forms/input';
import { A, P } from '../../../base/typography';
import { RawLoader } from '../../../loading/loading';
import * as StyledModals from '../myShipmentsModals.styles';
import { verifyPhoneInitialValues, verifyPhoneSchema } from './verifyPhone.schema';

interface Props {}

const VerifyPhone: FC<Props> = () => {
	const { t } = useTranslation('myShipments');
	const dispatch = useDispatch<any>();
	const userProfileReducer: IUserProfileReducer = useSelector<IStore, IUserProfileReducer>(
		store => store.userProfileReducer
	);

	const { userProfile } = userProfileReducer;

	const accountReducer: IAccountReducer = useSelector<IStore, IAccountReducer>(store => store.accountReducer);
	const { verificationId, modalSubmitPending, modalSubmitError, modalSubmitErrorDetails } = accountReducer;

	const closeModal = () => {
		dispatch(closeAllModals());
		document.body.style.overflow = 'unset';
	};
	document.body.style.overflow = 'hidden';

	useEffect(() => {
		if (userProfile?.phoneNumber) {
			dispatch(requestPhoneNumberVerificationToken(userProfile.phoneNumber));
		}
	}, [dispatch, userProfile?.phoneNumber]);

	if (!userProfile) return <RawLoader />;

	return (
		<StyledModals.Wrapper>
			<StyledModals.Heading>
				<div>{t('page-settings.verifyPhoneNumber')}</div>
				<A onClick={closeModal}>
					<Close />
				</A>
			</StyledModals.Heading>

			{modalSubmitError && (
				<StyledModals.ErrorMessage>
					<FaExclamationCircle />
					<div>{modalSubmitErrorDetails !== '' ? modalSubmitErrorDetails : t('genericError')}</div>
				</StyledModals.ErrorMessage>
			)}

			<P>{t('page-settings.verifyPhoneNumberMessage')}</P>
			<Formik
				initialValues={verifyPhoneInitialValues}
				validationSchema={verifyPhoneSchema}
				onSubmit={values => {
					dispatch(checkPhoneNumberVerificationToken(verificationId, values.code, userProfile));
				}}>
				<Form>
					<FormikFieldWrapper
						label={t('page-settings.verificationCode')}
						name="code"
						languageComponent="myShipments"
						smallLabel>
						<StyledFormikField type="text" id="code" name="code" placeholder={t('page-settings.code')} />
					</FormikFieldWrapper>

					<Button primary type="submit" isLoading={modalSubmitPending}>
						{t('page-settings.verify')}
					</Button>
				</Form>
			</Formik>
		</StyledModals.Wrapper>
	);
};

export default VerifyPhone;
